import { render, staticRenderFns } from "./FlowBase.vue?vue&type=template&id=0ed9ffde&"
import script from "./FlowBase.vue?vue&type=script&lang=js&"
export * from "./FlowBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports